import styles from './Obituary.module.scss'
import Hero from "@/Organisms/Obituary/Hero";
import Shortcuts from "@/Organisms/Obituary/Shortcuts";
import About from "@/Organisms/Obituary/About";
import Interactions from "@/Organisms/Obituary/Interactions";
import Actions from "@/Organisms/Obituary/Actions";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import {Interaction as InteractionType} from "@/types/interaction";
import Socials from "@/Organisms/Socials/Socials";
import PracticalInfo from "@/Organisms/Obituary/PracticalInfo";
import Photos from "@/Organisms/Photos/Photos";
import React from "react";
import Commercial, {CommercialType} from "@/Atoms/Commercial";
import useWindowSize from "@/helpers/useWindowSize";
import alert from "@/Atoms/Alert/Alert";




export default function Obituary(
  {
    person,
    showInteractions,
    stats,
    interactions,
    onAddReply,
    onAddHeart,
    claimed,
    background,
    manualHeight,
    mobileMenuIsOpen,
    functions,
    flash
  }: {
  person: Person,
  showInteractions: boolean,
  stats: InteractionStats,
  interactions: {
    data: InteractionType[],
    pages: number,
    page: number
  },
  onAddReply: (id: number, input: string) => Promise<any>,
  onAddHeart: (id: number) => Promise<boolean>,
  claimed?: boolean,
  background?: string,
  manualHeight?: number,
  mobileMenuIsOpen: boolean,
  functions?: {
    OnAddCondolence: () => void,
    OnAddFlower: () => void,
    OnAddCandle: () => void,
    OnSendCard: () => void,
    OnSendBouquet: () => void,
    OnSetMobileState: (state: boolean) => void,
  },
  flash: {
    message?: string
  }
}){



  const hasPractical = person.practical && Object.keys(person.practical).length !== 0
  const hasPhotos = person.photos?.length > 0;
  const hasAbout = person.about?.length > 10  && person.characteristics?.length > 0

  const {isMobile} = useWindowSize()


  const handleDownload = (image: string, index: number) => {
    location.href = `/overlijdensberichten/${person.slug}/ad/${index}/download`
  }
  // const advertisementUrls = person.advertisements?.map(ad => ad.url) || []
  const advertisementUrls: string[] = [];
  person.advertisements?.forEach(ad => ad.media.forEach(({url}) => advertisementUrls.push(url as string)))

  return <>
  <Hero
      person={person}
      stats={stats}
      claimed={claimed}
      background={background}
    />
    {claimed && <Shortcuts hasPractical={hasPractical} hasPhotos={hasPhotos} hasAbout={hasAbout} />}
    <section className={'p-5'}>
      <div className={`wrapper ${styles.wrapper}`}>

        <div className={styles.content}>

          {claimed && (<>
            {hasAbout && <About {...person} />}

            <div className={`${styles.group} md:hidden`}>
              <Socials person={person} />
            </div>
            <div className={'group'}>
              <h2><a id={'interactions'}></a>Condoleanceberichten</h2>

              {flash.message === 'need_reviewing' && <div className={styles.alert}>
                <h3>Bedankt voor uw condoleance</h3>
                <div>Voordat uw bericht geplaatst wordt, wordt deze automatisch gecontroleerd of er geen ongepaste woorden zijn gebruikt. Indien dit niet het geval is, wordt uw bericht automatisch direct geplaatst. Mocht er twijfel zijn, dan wordt het bericht niet zichtbaar bij de condoleances op de website. Het bericht wordt wel zichtbaar voor de nabestaanden in het beheeraccount. De nabestaanden kunnen dan zelf bepalen of ze het bericht verwijderen of wel willen opnemen op de website.</div>
              </div>}

              <Interactions
                interactions={interactions}
                onAddReply={onAddReply}
                onAddHeart={onAddHeart}
              />
            </div>
            {hasPractical && <div className={'group'}>
              <h2><a id={'practical'}></a>Praktische informatie</h2>
              <PracticalInfo {...person.practical} />
            </div>}

            {hasPhotos && <div className={'group'}>
              <h2><a id={'photos'}></a>Foto's</h2>
              <Photos images={person.photos || []}/>
            </div>}

          </>)}
          {advertisementUrls.length > 0 && <div className={'group'}>
              <h2><a id={'obituary'}></a>Overlijdensbericht</h2>
              <Photos
                  images={advertisementUrls}
                  onDownload={handleDownload}
              />
          </div>}

          {!claimed && (<>
            <div className={`${styles.group} md:hidden`}>
              <Socials person={person}/>
            </div>

            {person.obituary_type === 0 && isMobile &&
              <div><Commercial
                type={CommercialType.MediumRectangle} top/></div>
            }


            <Interactions
              interactions={interactions}
              onAddReply={onAddReply}
              onAddHeart={onAddHeart}
            />
          </>)}

        </div>

        <Actions
          showInteractions={showInteractions}
          person={person}
          manualHeight={manualHeight}
          {...functions}
          isOpen={mobileMenuIsOpen}
        />
      </div>
    </section>
  </>
}
